import { LitElement, html, css } from 'lit';

class MyAlert extends LitElement {
  
  static get styles() {
    return css`
      :host {
        display: block;
        color: #000;
      }
     .container {
        padding: 1em;
        color: #fff;
        font-weight: 500;
        display: block;
        border-radius: 2px;
      }
      svg {
        color: #fff;
        padding-right: 0.5em;
        width: 24px;
        height: 24px;
        float: left;
      }
      .error {
        background-color: #ef4444;
      }
      .success {
        background-color: #7aa944;
      }
      .info {
        background-color: #42a5f5;
      }
      .notification {
        background-color: #ff8f00;
      }
      slot[name=title] {
        font-size: 1.4em;
      }
      #content {
        margin-top: 1em;
      }
      slot[name=content] {
        font-weight: 300;
        font-size: 90%;
        line-height: 1.2;
        white-space: pre-line;
      }
      @media screen and (max-width: 414px) {
        :host {
          width: 330px;
        }
      }
    `;
  }

  constructor() {
    super();
    this.severity = '';
  }

  render() {
    return html`
    <div class="${this.severity} container">
      ${this.setIcon(this.severity)}
      <slot name="title"></slot>
      <div id="content"><slot name="content"></slot></div>
    </div>`;
  }

  static get properties() {
    return {
      severity: {
        type: String     
      },
    };
  }

  // eslint-disable-next-line class-methods-use-this
  setIcon(typeInput) {
    let icon = '';
    // eslint-disable-next-line default-case
    switch (typeInput) {
      case 'error':
        icon = html`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>`;
        break;
      case 'success':
        icon = html`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>`;
        break;
      case 'info':
        icon = html`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>`;
        break;
      case 'notification':
        icon = html`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><circle cx="12" cy="19" r="2"/><path d="M10 3h4v12h-4z"/></svg>`;
        break;
    }
    return icon;
  }

  static get is() {
    return 'my-alert';
  }
}
customElements.define(MyAlert.is, MyAlert);
